// Amplify v6 signIn() requires a username, so a fully usernameless passkey sign-in is not available through
// the library. We follow the Wealthsimple pattern (see ticket open question #1): remember the last email that
// successfully signed in on this browser and reuse it as the username hint for passkey sign-in. This keeps the
// UX usernameless in the common case (returning user on their own device) while satisfying Amplify's contract.
const REMEMBERED_EMAIL_KEY = 'sdc.lastEmail'

export const rememberEmail = (email: string): void => {
  try {
    window.localStorage.setItem(REMEMBERED_EMAIL_KEY, email.toLowerCase())
  } catch {
    // localStorage unavailable (private mode / disabled) — passkey login will ask for an email instead.
  }
}

export const getRememberedEmail = (): string | null => {
  try {
    return window.localStorage.getItem(REMEMBERED_EMAIL_KEY)
  } catch {
    return null
  }
}

export const clearRememberedEmail = (): void => {
  try {
    window.localStorage.removeItem(REMEMBERED_EMAIL_KEY)
  } catch {
    // no-op
  }
}
